/* src/app/components/payroll/corrections/reprocess/reprocess.component.css */
.table-style {
  width: 100%;
}
/*# sourceMappingURL=reprocess.component-H7YUXK2X.css.map */
